export { default } from './Video';
export type { Props, Props as VideoHeroBannerProps } from './Video';
